<template>
  <div class="oldmanleave">
    <el-row>
      <el-form :inline="true" class="demo-form-inline toolbar" style="padding-bottom:0px;padding-left:10px" :size="size">
        <el-form-item label="老人姓名">
          <el-input v-model.trim="userName" :placeholder="oldmanLeave.placeName" clearable
            @keyup.enter.native.prevent="enterSearchMember"></el-input>
        </el-form-item>
        <el-form-item label="老人身份证">
          <el-input v-model.trim="idCard" placeholder="请输入老人身份证" clearable
            @keyup.enter.native.prevent="enterSearchMember"></el-input>
        </el-form-item>
        <el-form-item>
          <kt-button icon="el-icon-search" label="查询" type="warning" @click="findPage" />
        </el-form-item>
        <el-form-item>
          <kt-button icon="el-icon-plus" label="新增" type="primary" @click="handleAdd" />
        </el-form-item>
        <el-form-item>
          <el-button
              type="info"
              @click="exportExcel"
              icon="el-icon-download"
              plain>记录导出</el-button>
        </el-form-item>

      </el-form>
    </el-row>
    <el-row>
      <!-- 表格内容栏 -->
      <el-table :data="filterColumns" style="width: 100%" :header-cell-style="{
        'text-align': 'center',
        'font-size': '16px',
        'font-weight': '600',
        color: '#2d2d2d',
        'background-color': '#d4f5fa',
      }" :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :row-style="tableRowStyle">
        <el-table-column prop="oldName" label="老人姓名" width="140" align="center"></el-table-column>
        <el-table-column prop="oldIdCard" label="身份证号" width="185" align="center"></el-table-column>
        <el-table-column prop="newBedNo" :label="oldmanLeave.bedNo" align="center"></el-table-column>
        <el-table-column prop="type" :label="oldmanLeave.type" align="center"></el-table-column>
        <el-table-column prop="leaveDate" :label="oldmanLeave.time" align="center"></el-table-column>
        <el-table-column prop="returnDate" :label="oldmanLeave.timeback" align="center"></el-table-column>
        <el-table-column prop="realDate" :label="oldmanLeave.realtime" width="120" align="center">
          <template slot-scope="scope">
            <a class="curcor" @click="fixReturnTime(scope.row);">
              <span style="margin-right:6px;font-size:16px">{{ scope.row.realDate }}</span>
              <img v-if="scope.row.realDate == null" src="@/assets/beadhouse/zhuanru.png" />
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="desc" :label="oldmanLeave.desc" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="success" size="mini" plain @click="fixOldmanLeave(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <!-- 实际回院的dialog模态框 -->
    <el-dialog title="选择时间" :visible.sync="TimedialogVisible" width="30%">
      <el-row type="flex" justify="center">
        <p>实际回院时间：</p>
        <el-date-picker v-model="realTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"></el-date-picker>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="TimedialogVisible = false;">取 消</el-button>
        <el-button type="primary" @click="addRealTime">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 老人请假的dialog模态框 -->
    <el-dialog class="oldmanleavedialog" :title="operation ? oldmanLeave.addLeave : oldmanLeave.quearyLeave" width="30%"
      :visible.sync="dialogVisibleOlamanLeaveForm" :close-on-click-modal="false" @close="closeOldmanleaveDialog">
      <el-form :model="olamanLeaveForm" label-width="120px" :rules="olamanLeaveFormRules" ref="olamanLeaveForm"
        label-position="right">
        <el-form-item label="老人姓名" prop="oldName">
          <el-autocomplete v-model.trim="olamanLeaveForm.oldName" auto-complete="off" placeholder="请输入老人姓名"
            style="width:80%" :fetch-suggestions="querySearchAsync" @select="handleOlderSelect"
            :disabled="disabled"></el-autocomplete>
        </el-form-item>
        <el-form-item label="身份证号" prop="oldIdCard">
          <el-input v-model="olamanLeaveForm.oldIdCard" style="width:80%" disabled></el-input>
        </el-form-item>
        <el-form-item :label="oldmanLeave.bedNo" prop="newBedNo">
          <el-input v-model="olamanLeaveForm.newBedNo" style="width:80%" disabled></el-input>
        </el-form-item>
        <!-- 请假原因 -->
        <el-form-item :label="oldmanLeave.leavaReason" prop="type">
          <el-select v-model="olamanLeaveForm.type" :placeholder="oldmanLeave.placeHolder" style="width:80%"
            :disabled="disabled">
            <el-option v-for="item in leaveReasonOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="oldmanLeave.leaveStart" prop="leaveDate">
          <el-date-picker style="width:80%" :editable="false" :clearable="false" v-model="olamanLeaveForm.leaveDate"
            type="date" :placeholder="oldmanLeave.placeTime" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
            :disabled="disabled"></el-date-picker>
        </el-form-item>
        <el-form-item :label="oldmanLeave.leaveEnd" prop="returnDate">
          <el-date-picker style="width:80%" :editable="false" :clearable="false" v-model="olamanLeaveForm.returnDate"
            type="date" :placeholder="oldmanLeave.placeTime" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
            :disabled="disabled"></el-date-picker>
        </el-form-item>
        <el-form-item :label="oldmanLeave.desc" prop="desc">
          <el-input v-model="olamanLeaveForm.desc" style="width:80%" type="textarea" :rows="3" auto-complete="off"
            :placeholder="oldmanLeave.placedesc" :disabled="disabled"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button v-if="operation" :size="size" @click.native="dialogVisibleOlamanLeaveForm = false;">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitFormOlamanLeaveForm('olamanLeaveForm');"
          :loading="olamanLeaveFormLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 分页 -->
    <el-pagination class="center-pg fenye" ref="pagination" background @current-change="handleCurrentChange"
      :page-size="10" layout="total, prev, pager, next" align="center" :total="total"></el-pagination>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import { baseURL } from "@/utils/request.js";
import KtButton from "@/components/KtButton";
export default {
  name: "OldmanLeave",
  components: { KtTable, KtButton },
  data() {
    return {
      leaveDate: "", //请假时间
      oldmanLeave: {
        placeName: "请输入姓名",
        queary: "查询",
        bedNo: "床位号",
        type: "请假类型",
        time: "请假时间",
        timeback: "预计回院时间",
        realtime: "实际回院时间",
        moneyback: "退款天数",
        desc: "说明",
        addLeave: "新增请假",
        quearyLeave: "查看请假",
        leavaReason: "请假原因",
        placeHolder: "请选择",
        leaveStart: "请假开始时间",
        leaveEnd: "请假结束时间",
        placeTime: "选择日期",
        placedesc: "请输入请假说明"
      }, //引入中文字符
      disabled: true,
      loading: true,
      size: "medium", //按钮的尺
      userName: "", //查询老人输入框
      idCard: "", // 查询老人身份证输入框
      filterColumns: [],
      TimedialogVisible: false, //实际回院时间弹窗
      realTime: "", //弹窗实际回院时间
      //老人请假的dialog配置
      operation: true,
      dialogVisibleOlamanLeaveForm: false,
      olamanLeaveFormRules: {
        oldName: [
          { required: true, message: "请输入老人姓名", trigger: "change" }
        ],
        leaveDate: [
          { required: true, message: "请输入请假时间", trigger: "blur" }
        ],
        desc: [{ required: true, message: "请输入说明内容", trigger: "blur" }],
        type: [{ required: true, message: "请输入请假原因", trigger: "change" }]
      },
      olamanLeaveFormLoading: false,
      //配置请假类型
      leaveReasonOptions: [
        {
          label: "回家",
          value: 1
        },
        {
          label: "和好友外出",
          value: 2
        },
        {
          label: "院外就医",
          value: 3
        },
        {
          label: "院内就医",
          value: 4
        }
      ],
      //表单内容
      olamanLeaveForm: {},
      oldId: "", //老人id
      currentId: "", //当前列的id
      pageNum: "1", //当前页
      pageSize: "10",
      total: 0 //总页
    };
  },
  methods: {
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    //enter键查询
    enterSearchMember() {
      this.findPage();
    },

    //修改实际回院时间
    fixReturnTime(row) {
      if (!row.realDate) {
        this.leaveDate = row.leaveDate;
        this.TimedialogVisible = true;
        this.currentId = row.id;
        this.realTime = "";
      }
    },
    //导出
    exportExcel() {
      window.location.href =
      baseURL +
      `omc/api/downOldLeaveTableExcel?groupId=${window.sessionStorage.getItem("groupId")}`;
    },
    //修改实际回院时间接口
    addRealTime() {
      if (this.realTime) {
        if (Date.parse(this.realTime) < Date.parse(this.leaveDate)) {
          this.$message({
            message: "实际回院时间不能早于请假开始时间",
            type: "error"
          });
        } else {
          let param = {
            id: this.currentId,
            realDate: this.realTime
          };
          this.$postJson("omc/oldLeave/sell", param).then(res => {
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
              this.TimedialogVisible = false;
              this.findPage(); //重新渲染页面
            } else {
              this.$message({ message: res.message, type: "error" });
            }
          });
        }
      } else {
        this.$message({ message: "实际回院时间不能为空", type: "error" });
      }
    },

    //关闭弹窗
    closeOldmanleaveDialog() {
      //by guo 2019-12-22-20:48 注释 有bug 点击叉号关闭查看的dialog模态框的时候会，下一行的页点击叉号关闭  会使下一行的数据也变成第一行的数据
      // this.$nextTick(() => {
      //   if (this.$refs["olamanLeaveForm"]) {
      //     this.$refs["olamanLeaveForm"].resetFields(); //清空添加数据
      //   }
      // });
    },
    //添加按钮 跳转页面
    handleAdd() {
      this.$nextTick(() => {
        if (this.$refs["olamanLeaveForm"]) {
          this.$refs["olamanLeaveForm"].resetFields(); //清空添加数据
        }
      });
      this.disabled = false;
      this.dialogVisibleOlamanLeaveForm = true;
      this.operation = true;
      this.olamanLeaveForm = {
        oldName: "",
        oldIdCard: "",
        newBedNo: "",
        type: "",
        leaveDate: "",
        returnDate: "",
        returnDate: "",
        desc: ""
      };
    },

    //修改老人请假
    fixOldmanLeave(row) {
      this.disabled = true;
      this.dialogVisibleOlamanLeaveForm = true;
      this.operation = false;
      this.olamanLeaveForm = row;
    },

    //翻页
    handleCurrentChange(val) {
      this.pageNum = val;
      this.findPage();
    },

    //查询列表
    findPage() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        oldName: this.userName,
        idCard: this.idCard
      };
      this.$postJson("omc/oldLeave/showAll", param).then(res => {
        if (res.code == 200) {
          let list = res.result.list;
          this.total = Number(res.result.total);
          var maps = new Map([
            [1, "回家"],
            [2, "和好友外出"],
            [3, "院外就医"],
            [4, "院内就医"]
          ]);
          this.filterColumns = list.map(element => {
            element.type = maps.get(element.type);
            return element;
          });
        } else {
          this.$message({ message: "查询失败" + res.message, type: "error" });
        }
      });
    },

    //上传表单
    submitFormOlamanLeaveForm(olamanLeaveForm) {
      //校验表单
      this.$refs[olamanLeaveForm].validate(valid => {
        if (valid) {
          let param = {
            oldManId: this.oldId,
            leaveDate: this.olamanLeaveForm.leaveDate,
            returnDate: this.olamanLeaveForm.returnDate,
            type: this.olamanLeaveForm.type,
            desc: this.olamanLeaveForm.desc
          };
          this.$postJson("omc/oldLeave/add", param).then(res => {
            if (res.code == 200) {
              this.dialogVisibleOlamanLeaveForm = false; //关闭弹窗
              this.$nextTick(() => {
                this.$refs[olamanLeaveForm].resetFields(); //清空添加数据
              });
              this.$message({ message: "添加成功", type: "success" });
              this.findPage(); //重新渲染页面
            } else {
              this.$message({
                message: "添加失败, " + res.message,
                type: "error"
              });
            }
          });

        } else {
          return false;
        }
      });
    },

    // 分页刷新数据
    refreshPageRequest(data) {
      console.log(data);
      this.pageRequest.pageNum = data;
      this.findPage();
    },

    //模糊查询老人
    querySearchAsync(queryString, cb) {
      // let nursingGroupId = sessionStorage.getItem('nursingGroupId')
      let param = {
        oldmanName: this.olamanLeaveForm.oldName
      };
      this.$postForm("omc/oldLeave/queryOldmanList", param).then(res => {
        var list = [{}];
        if (res.result) {
          for (let i of res.result) {
            i.value = i.oldmanName; //将想要展示的数据作为value
          }
          list = res.result;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: ""
          });
          cb(arr);
          setTimeout(() => {
            this.olamanLeaveForm.oldName = "";
          }, 1000);
        }
      });
    },

    //根据选取老人获取老人id
    handleOlderSelect(item) {
      this.olamanLeaveForm.oldIdCard = item.idCard;
      this.oldId = item.oldmanId;
      this.olamanLeaveForm.newBedNo = item.bedNo;
    },

  },
  mounted() {
    this.findPage();
  }
};
</script>
<style lang="scss" scoped>
.oldmanleave {
  width: 100%;
  min-height: 500px;
  background: #fefefe;
}

.curcor {
  cursor: pointer;
  margin-left: 5px;
  margin-right: 5px;
}

// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: center;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

::v-deep .oldmanleavedialog .el-dialog .el-dialog__body {
  padding-bottom: 0px;
}

::v-deep .el-dialog__header {
  height: 19px !important;
  text-align: left;
}

::v-deep .el-dialog__footer {
  text-align: center;
}
</style>
